<template>
  <div class="group-game">
    <div class="ggame-heading">
      <h2 class="ggame-heading-text">{{outrightsselected.name | offerlang}} - {{betgroupselected.name | offerlang}}</h2>
    </div>
    <div class="single-game-sport outrights">
      <div class="sgame-groups-container">
        <div class="sgame-odds-box" v-for="(oddType, ot) in betgroupselected.oddTypes" :key="ot">
          <p class="sgame-odds-header">{{oddType.name | offerlang}}</p>
          <div class="sgame-odds-container">
            <div class="sgame-odds-content">
              <div class="sgame-odd" v-for="(odd, key) in oddType.odds" :key="key">
                <div class="sgame-odd-header">{{odd.name | offerlang}}</div>
                <div class="sgame-odd-value odd-result no-odd">
                  <img v-if="odd.status == 'win'" src="../../../assets/img/won.svg" class="spec-odd-status">
                  <img v-else-if="odd.status == 'lost'" src="../../../assets/img/lost.svg" class="spec-odd-status">
                  <img v-else-if="odd.status == 'refund'" src="../../../assets/img/refund.svg" class="spec-odd-status">
                  <img v-else src="../../../assets/img/waiting-light.svg" class="spec-odd-status">
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

import { mapActions, mapGetters } from 'vuex';

export default {
    name: 'OutrightsSingleResults',
    props: ['betgroupselected', 'outrightsselected'],
    data()
    {
        return {

        };
    },
    methods:
    {
        ...mapActions([

        ]),
    },
    watch:
    {

    },
    computed:
    {
        ...mapGetters([
            'isMobile',
        ]),
    },
};
</script>
